"use strict";

var _ = require("underscore");
var Reflux = require("reflux");
var SignalActions = require("app/shared/actions/signal-actions");

var SignalStore = Reflux.createStore({
  state: {
    open: null,
    type: "success",
    instant: false,
    hideTimeout: null
  },

  init: function(){
    this.listenTo(SignalActions.show, this.show);
    this.listenTo(SignalActions.hide, this.hide);
    this.listenTo(SignalActions.instantHide, this.instantHide);
  },

  show: function(props) {
    Object.assign(this.state, props);
    this.state.open = true;
    this.state.instant = false;

    this.dispatch();

    if(this.state.hideTimeout) {
      this.state.timeout = setTimeout(function() {
        SignalActions.hide();
      }, this.state.hideTimeout);
    }
  },

  hide: function() {
    this.state.open = false;

    this.dispatch();
  },

  instantHide: function() {
    this.state.open = false;
    this.state.instant = true;

    this.dispatch();
  },

  dispatch: function() {
    this.trigger(this.state);

    if(this.state.timeout != null) {
      clearTimeout(this.state.timeout);
    }
  }
});

module.exports = SignalStore;



// WEBPACK FOOTER //
// ./app/shared/stores/signal-store.js